/**
 * @file
 * A JavaScript file for the site.
 *
 * @copyright Copyright 2019 Palantir.net
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth

(function ($) {

  // Select all links with hashes
  $('.a-z-anchor-nav a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function(event) {
      // Determine if on-page links
      if (
        location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '')
        &&
        location.hostname === this.hostname
      ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        // Get the height of the main nav and anchor nav.
        var anchorNavHeight = $('.a-z-anchor-nav').outerHeight();
        var topNavHieght = $('.site-header').outerHeight();
        var totalAboveHeight = topNavHieght + anchorNavHeight ;

        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
          // Subtract height of main nav and anchor nav from total offset of target.
          let scrollTopValue = target.offset().top - totalAboveHeight;
          // Is it a top link?
          if (target.attr('id') === 'a-z-top') {
            scrollTopValue = "0";
          }
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $('html, body').animate({
            scrollTop: scrollTopValue,
          }, 1000, function() {
            // Callback after animation
            // Must change focus!
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) { // Checking if the target was focused
              return false;
            } else {
              $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
              $target.focus(); // Set focus again
            };
          });
        }
      }
    });


  // Add class to back to top link on scroll
  $(window).scroll(function() {
    if ($('#a-z-top').length) {
      const anchorScroll = $(window).scrollTop();
      const anchorNav = $('#a-z-top').offset();

      if (anchorScroll >= anchorNav.top) {
        $('.a-z-anchor-nav__top-link').addClass('is-sticky');
      } else {
        $('.a-z-anchor-nav__top-link').removeClass('is-sticky');
      }
    }

  });

})(jQuery);
